var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { connect } from 'react-redux';


import formatter from "../../Metadata/helpers/formater";
import { safeName } from "../../../shared/propertyNames";
import { showByType } from "../../Metadata/components/Metadata";
import { Translate } from "../../I18N";

import { ensure } from "../../../shared/tsUtils";
import { logError } from "../utils";












const mapStateToProps = ({ entityView, templates, thesauris, settings }) => ({
  entity: entityView.entity,
  templates,
  thesauri: thesauris,
  newNameGeneration: settings.collection.get('newNameGeneration') || false
});

const connector = connect(mapStateToProps);




const rootProperties = ['title', 'creationDate', 'editDate'];

const getPropertyData = ({ formattedEntity, propertyName, newNameGeneration }) =>
formattedEntity.metadata.find((p) => p.name === safeName(propertyName, newNameGeneration));

const extractRootProperty = ({ formattedEntity, propertyName }) =>
formattedEntity[propertyName];

const extractMetadataProperty = ({ formattedEntity, propertyName, newNameGeneration }) => {
  const propertyData = formattedEntity.metadata.find(
    (p) => p.name === safeName(propertyName, newNameGeneration)
  );
  return showByType({ prop: propertyData, compact: false });
};

const extractRootLabel = ({ propertyName, template: _template }) => {var _template$get;
  const template = ensure(_template);
  const term =
  ((_template$get = template.
  get('commonProperties')) === null || _template$get === void 0 ? void 0 : _template$get.
  find((p) => (p === null || p === void 0 ? void 0 : p.get('name')) === propertyName).
  get('label')) || '';

  const context = propertyName === 'title' ? template.get('_id') : 'System';
  return /*#__PURE__*/_jsx(Translate, { context: context }, void 0, term);
};

const extractMetadataLabel = ({ formattedEntity, propertyName, newNameGeneration }) => {
  const propertyData = getPropertyData({ formattedEntity, propertyName, newNameGeneration });
  return /*#__PURE__*/_jsx(Translate, { context: propertyData.translateContext }, void 0, propertyData.label);
};

const getProperty = (
propValueOf,
propLabelOf) =>
{
  if (propValueOf && propLabelOf) {
    throw new Error('Can\'t provide both "value-of" and "label-of".');
  }

  const property = propValueOf || propLabelOf;

  if (!property) {
    throw new Error('"value-of" or "label-of" must be provided.');
  }

  return property;
};

const getMethod = (propValueOf, propertyName) => {
  const isRootProperty = rootProperties.includes(propertyName);

  if (propValueOf) {
    return isRootProperty ? extractRootProperty : extractMetadataProperty;
  }

  return isRootProperty ? extractRootLabel : extractMetadataLabel;
};

const EntityData = ({
  entity,
  templates,
  thesauri,
  'value-of': propValueOf,
  'label-of': propLabelOf,
  newNameGeneration
}) => {
  const formattedEntity = formatter.prepareMetadata(entity.toJS(), templates, thesauri);
  const template = templates.find((t) => (t === null || t === void 0 ? void 0 : t.get('_id')) === entity.get('template'));
  // eslint-disable-next-line react/jsx-no-useless-fragment
  let output = /*#__PURE__*/React.createElement(React.Fragment, null);

  try {
    const propertyName = getProperty(propValueOf, propLabelOf);
    const renderMethod = getMethod(propValueOf, propertyName);
    output = /*#__PURE__*/React.createElement(React.Fragment, null, renderMethod({ formattedEntity, propertyName, newNameGeneration, template }));
  } catch (err) {
    logError(err, propValueOf, propLabelOf);
  }

  return output;
};

const container = connector(EntityData);
export { container as EntityData };